import {action, observable} from "mobx";
import etTranslations from "../locale-et.json";
import {ITranslation, LanguageEnum} from "../models/translation";
import BaseStore from "./base/base-store";
import RootStore from "./root-store";

export default class TranslationStore extends BaseStore {
    private static initLanguage(): string {
        const cookieString = "; " + document.cookie;
        const cookies = cookieString.split("; language=");

        if (cookies.length === 2) {
            return cookies.pop().split(";").shift();
        }

        return process.env.REACT_APP_LANGUAGE;
    }

    public language: string;

    @observable
    private translations: ITranslation[];

    constructor(rootStore: RootStore) {
        super(rootStore);
        this.language = TranslationStore.initLanguage();
    }

    public translate(key: string, defaultValue: string, replacedValue?: any): string {
        const translation = this.translations && this.translations.find(trans => trans.key === key);
        let result = translation && translation.value || defaultValue;

        if (replacedValue != null) {
            result = result.replace("{0}", replacedValue);
        }

        return result;
    }

    public changeLanguage(language: LanguageEnum) {
        document.cookie = `language=${language}`;
        this.language = language;
        this.applyTranslations(true);
    }

    public applyTranslations(force: boolean = false) {
        if (this.language === LanguageEnum.et) {
            this.setTranslations(etTranslations, force);
        } else {
            this.setTranslations([], force);
        }
    }

    @action
    private setTranslations(translations: ITranslation[], force: boolean) {
        if (!this.translations || force) {
            this.translations = translations;
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/translation-store.ts